import { Link } from "react-router-dom";
import { Logo } from "./Bits";
import { MessageCircle } from "lucide-react";

const WA = "https://wa.me/919000000000?text=Hi+BookMyCarer";

export default function Footer() {
  const cats = [
    ["Elder & Disability", "elder"], ["Nursing & Clinical", "nursing"], ["Physio & Speech", "physio"],
    ["Personal & Daily Living", "personal"], ["Mother & Baby", "mother"], ["Mental Health", "mental"],
    ["Pet Care", "pet"], ["Wellness & Lifestyle", "wellness"],
  ];
  return (
    <footer className="bg-ink text-ivory mt-24">
      <div className="bmc-wrap py-16 grid md:grid-cols-4 gap-10">
        <div>
          <Logo light />
          <p className="text-sm text-ivory/60 mt-4 leading-relaxed">India's most loved care marketplace. Verified carers for elders, patients, mothers and families — booked in minutes.</p>
          <p className="text-xs text-ivory/40 mt-4">Secure payments: UPI · Razorpay</p>
          <a href={WA} target="_blank" rel="noreferrer" className="btn-pill bg-[#25D366] text-white px-4 py-2 text-sm mt-4" data-testid="footer-whatsapp">
            <MessageCircle size={15} /> WhatsApp us
          </a>
        </div>
        <div>
          <h5 className="font-display font-bold mb-4">Find Care</h5>
          <ul className="space-y-2.5 text-sm text-ivory/60">
            {cats.map(([l, k]) => <li key={k}><Link to={`/find-care?cat=${k}`} className="hover:text-coral">{l}</Link></li>)}
          </ul>
        </div>
        <div>
          <h5 className="font-display font-bold mb-4">Company</h5>
          <ul className="space-y-2.5 text-sm text-ivory/60">
            <li><Link to="/how-it-works" className="hover:text-coral">How it works</Link></li>
            <li><Link to="/trust-safety" className="hover:text-coral">Trust & safety</Link></li>
            <li><Link to="/nri" className="hover:text-coral">For NRIs</Link></li>
            <li><Link to="/become-a-carer" className="hover:text-coral">Become a carer</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="font-display font-bold mb-4">Support</h5>
          <ul className="space-y-2.5 text-sm text-ivory/60">
            <li><a href={WA} target="_blank" rel="noreferrer" className="hover:text-coral">Help centre</a></li>
            <li><a href={WA} target="_blank" rel="noreferrer" className="hover:text-coral">WhatsApp us</a></li>
            <li><span className="hover:text-coral cursor-pointer">Terms</span></li>
            <li><span className="hover:text-coral cursor-pointer">Privacy</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="bmc-wrap py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-ivory/40">
          <span>© 2026 BookMyCarer Pvt. Ltd. · CIN: U85399TG2026PTC000000</span>
          <span>Hyderabad & Bengaluru</span>
        </div>
      </div>
    </footer>
  );
}
